export enum MultimediaBucket {
  Shop = 'shop',
  Warehouse = 'warehouse',
}
